/* 🤖 this file was generated by svg-to-ts */
export const matIconSimCardDownload: {
  name: 'sim-card-download';
  data: string;
} = {
  name: 'sim-card-download',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18z"/><path d="m16 13-4 4-4-4 1.41-1.41L11 13.17V9.02L13 9v4.17l1.59-1.59L16 13z"/></svg>`
};
